<template>
  <div class="modal-overlay" v-if="isVisible" @click.self="close">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ $t('supplyRequestModal.title') }}</h4>
          <button type="button" class="btn-close" @click="close" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>{{ $t('supplyRequestModal.description') }}</p>

          <form @submit.prevent="submitSupply">
            <div class="mb-3">
              <label class="form-label">{{ $t('supplyRequestModal.phone_label') }}</label>
              <input type="number" v-model="phone" :placeholder="$t('supplyRequestModal.phone_placeholder')" class="form-control" required />
            </div>

            <div class="mb-3">
              <label class="form-label">{{ $t('supplyRequestModal.name_label') }}</label>
              <input type="text" v-model="sellerName" :placeholder="$t('supplyRequestModal.name_placeholder')" class="form-control" required />
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="submitSupply">{{ $t('supplyRequestModal.submit') }}</button>
          <button type="button" class="btn btn-outline-primary" @click="close">{{ $t('supplyRequestModal.close') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { t } = useI18n()
const props = defineProps({
  product: { type: Object, required: true }
})
const emit = defineEmits(['close'])

const isVisible = ref(true)
const phone = ref('')
const sellerName = ref('')

const close = () => {
  isVisible.value = false
  emit('close')
}

const submitSupply = async () => {
  if (!phone.value || !sellerName.value) {
    alert(t('supplyRequestModal.fill_all'))
    return
  }

  try {
    await $fetch('/market/api/products/supply', {
      method: 'POST',
      body: {
        product_id: props.product.id,
        phone: phone.value,
        seller_name: sellerName.value
      }
    })
    alert(t('supplyRequestModal.success'))
    close()
  } catch (e) {
    alert(t('supplyRequestModal.error'))
  }
}
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.modal-dialog {
  width: 100%;
  max-width: 500px;
  margin: auto;
}

.modal-content {
  background: #fff;
  border-radius: $r-lg;
  overflow: hidden;
  box-shadow: $shadow-warm-lg;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid $line;

  .modal-title {
    margin: 0;
    font-size: 1rem;
    font-weight: 700;
    color: $ink;
  }

  .btn-close {
    background: transparent;
    border: none;
    font-size: 1.2rem;
    cursor: pointer;
    opacity: 0.6;
    transition: opacity 0.2s;
    &:hover { opacity: 1; }
  }
}

.modal-body {
  padding: 20px;
  font-size: 0.88rem;
  line-height: 1.8;
  color: $ink;

  p { margin: 0 0 14px; }

  .form-control {
    border-radius: $r-sm;
    border: 1px solid #ddd;
    padding: 10px 15px;
    font-family: inherit;
    width: 100%;

    &:focus {
      border-color: $leaf;
      box-shadow: 0 0 0 0.2rem rgba(3, 160, 84, 0.25);
      outline: none;
    }
  }

  .form-label {
    font-weight: 600;
    margin-bottom: 8px;
    display: block;
    font-size: 0.84rem;
  }

  .mb-3 { margin-bottom: 14px; }
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 20px;
  border-top: 1px solid $line;

  .btn {
    padding: 8px 18px;
    border-radius: $r-pill;
    font-size: 0.84rem;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    transition: all 0.25s;
    border: 1.5px solid;

    &.btn-primary {
      background: $leaf;
      border-color: $leaf;
      color: #fff;

      &:hover { background: $leaf-deep; border-color: $leaf-deep; }
      &:active { transform: scale(0.97); }
    }

    &.btn-outline-primary {
      background: transparent;
      border-color: $leaf;
      color: $leaf;

      &:hover { background: $leaf; color: #fff; }
      &:active { transform: scale(0.97); }
    }
  }
}
</style>
